import { Navigate } from "react-router-dom";

import ActivateUser from "Pages/Registration/ActivateUser";
import AdminConfiguration from "Pages/Admin/AdminConfiguration/AdminConfiguration";
import AgentStatus from "Pages/Admin/AgentStatus/AgentStatus";
import Autologin from "components/Autologin";
import ClientHealth from "Pages/Admin/ClientHealth/ClientHealth";
import ClientMap from "Pages/Admin/ClientMap/ClientMap";
import CompanyMethods from "Pages/Admin/CompanyMethods/CompanyMethods";
import CompanySetup from "Pages/Admin/CompanySetup/CompanySetup";
import Configuration2 from "Pages/Setup/Configuration2/Configuration2";
import EditIntegrations2 from "Pages/Integration/EditIntegrations2/EditIntegrations2";
import EditMatchTools from "Pages/Admin/EditMatchTools/EditMatchTools";
import EmailRules from "Pages/Tools/EmailRules/EmailRules";
import Integrations from "Pages/Integration/Integrations";
import Login from "Pages/Login/Login";
import LoginAs from "Pages/Login/LoginAs";
import LoginCompany from "Pages/Login/LoginCompany/LoginCompany";
import ManageRoles from "Pages/Users/ManageRoles/ManageRoles";
import ManageUsers from "Pages/Users/ManageUsers/ManageUsers";
import MatchToolsSetup from "Pages/Tools/MatchTools/MatchToolsSetup";
import MessageSearch from "Pages/Tools/MessageSearch/MessageSearch";
import NotFound from "Pages/NotFound/NotFound";
import OAuth from "Pages/Login/OAuth";
import PrivateRoute from "components/PrivateRoute";
import Run from "Pages/Run/Run";
import RunDetails from "Pages/Run/RunDetails/RunDetails";
import Scheduler from "Pages/Setup/Scheduler/Scheduler";
import ShuttleStatus from "Pages/Admin/ShuttleStatus/ShuttleStatus";
import StatusMessages from "Pages/Admin/StatusMessages/StatusMessages";
import StuckIntegrations from "Pages/Admin/StuckIntegrations/StuckIntegrations";
import StuckJobs from "Pages/Admin/StuckJobs/StuckJobs";
import SuiteQLSearch from "Pages/Tools/SuiteQLSearch/SuiteQLSearch";
import Support from "Pages/Help/Support/Support";
import SupportV2 from "Pages/Help/SupportV2/SupportV2";
import TestConnection from "Pages/Setup/TestConnection/TestConnection";
import Onboarding from "Pages/Setup/Connect/Onboarding";
import BillyOnboarding from "Pages/Setup/Connect/BillyOnboarding";

export const routes = [
    // ===== Unprotected routes (Add Everything as child of PrivateRoute below unless there's a reason not to)=====
    {
        path: "/activate_user",
        element: <ActivateUser />,
    },
    {
        path: "/",
        element: <Navigate to="/login" />,
    },
    {
        path: "/login",
        element: <Autologin />,
        children: [
            {
                path: "",
                element: <Login />,
            },
        ],
    },
    {
        path: "/login_company",
        element: <LoginCompany />,
    },
    {
        path: "not_found",
        element: <NotFound />,
    },
    {
        path: "/oauth",
        element: <OAuth />,
    },

    // ===== Protected routes wrapped in PrivateRoute component require authorization =====
    {
        element: <PrivateRoute />,
        children: [
            {
                path: "/admin/agent_status",
                element: <AgentStatus />,
            },
            {
                path: "/admin/status_messages",
                element: <StatusMessages />,
            },
            {
                path: "/admin/config",
                element: <AdminConfiguration />,
            },
            {
                path: "/admin/client_health/summary",
                element: <ClientHealth />,
            },
            {
                path: "/admin/company",
                element: <CompanySetup />,
            },
            {
                path: "/admin/company_methods",
                element: <CompanyMethods />,
            },
            {
                path: "/admin/edit_match_tools",
                element: <EditMatchTools />,
            },
            {
                path: "/admin/edit_integrations",
                element: <EditIntegrations2 />,
            },
            {
                path: "/admin/edit_integrations2",
                element: <EditIntegrations2 />,
            },
            {
                path: "/admin/login_as",
                element: <LoginAs />,
            },
            {
                path: "/admin/map",
                element: <ClientMap />,
            },
            {
                path: "/admin/shuttle_status",
                element: <ShuttleStatus />,
            },
            {
                path: "/admin/stuck_integrations",
                element: <StuckIntegrations />,
            },
            {
                path: "/admin/stuck_jobs",
                element: <StuckJobs />,
            },
            {
                path: "/admin/system",
                element: <CompanySetup />,
            },
            {
                path: "/help/support",
                element: <Support />,
            },
            {
                path: "/help/support-v2",
                element: <SupportV2 />,
            },
            {
                path: "/integrations",
                element: <Integrations />,
            },
            {
                path: "/run",
                element: <Run />,
            },
            {
                path: "/run_details/:messageHeaderId",
                element: <RunDetails />,
            },
            {
                path: "/setup/configuration",
                element: <Configuration2 />,
            },
            {
                // Legacy URL kept as alias so any bookmarks still resolve.
                path: "/setup/configuration2",
                element: <Navigate to="/setup/configuration" replace />,
            },
            {
                path: "/setup/test_connection",
                element: <TestConnection />,
            },
            {
                // Unadvertised — guided onboarding (left-rail task flow + right
                // value panels). Not in the nav; reachable by direct URL while
                // onboarding pages are in trial.
                path: "/setup/connect",
                element: <Onboarding />,
            },
            {
                // Billy + Sage Intacct twin of /setup/connect. Separate page
                // rather than a mode on Onboarding, which is Ramp/CMiC-specific
                // throughout (GL classifications, posting defaults, key players).
                path: "/setup/connect_billy",
                element: <BillyOnboarding />,
            },
            {
                path: "/setup/scheduler",
                element: <Scheduler />,
            },
            {
                path: "/tools/email_rules",
                element: <EmailRules />,
            },
            {
                path: "/tools/message_search",
                element: <MessageSearch />,
            },
            {
                path: "/tools/suiteql_search",
                element: <SuiteQLSearch />,
            },
            {
                path: "/tools/match_tools/:tool",
                element: <MatchToolsSetup />,
            },
            {
                path: "/users/manage",
                element: <ManageUsers />,
            },
            {
                path: "/users/roles",
                element: <ManageRoles />,
            },
        ],
    },
    {
        element: (
            <Navigate
                to="/not_found"
                state={{ url: window.location.href }}
                replace
            />
        ),
        path: "*",
    },
];
